import { EventEmitter, Injectable, Type } from "@angular/core";
import { IAccountingProcessAccount } from "rl-common/services/accounting-processes/models/i-accounting-process-account";
import { IAccountingProcessAccountGroup } from "rl-common/services/accounting-processes/models/i-accounting-process-account-group";
import { IAccountingProcessAccountGroupRuleSet } from "rl-common/services/accounting-processes/models/i-accounting-process-account-group-rule-set";
import { ModalAdapter } from "rl-common/services/modal-adapter/modal-adapter";
import { IBuildAccountGroupRuleSetResult } from "./build-account-group-rule-set-modal.models";

export interface IBuildAccountGroupRuleSetModalComponent {
	accounts: IAccountingProcessAccount[];
	accountGroup: IAccountingProcessAccountGroup;
	accountGroupRuleSet: IAccountingProcessAccountGroupRuleSet;
	/** highest sequence number already used in this group; a new Set is appended after it */
	maxSequenceNumber: number;
	/** existing Set names in this group, so the name can be checked for duplicates */
	existingNames: string[];
	onClose: EventEmitter<IBuildAccountGroupRuleSetResult>;
}

@Injectable({ providedIn: "root" })
export class BuildAccountGroupRuleSetModalAdapter extends ModalAdapter<IBuildAccountGroupRuleSetModalComponent> {
	constructor(type: Type<IBuildAccountGroupRuleSetModalComponent>) {
		super(type);
	}

}
